import { Injectable } from "@angular/core";
import { FormArray } from "@angular/forms";
import * as _ from "lodash";

@Injectable({
    providedIn: "root",
})
export class FinanceUtilityService {

    /** Recursive method to prepare chart of accounts data */
    getAccountTypes(isParentSelectable, isChildSelectable, accounts, isBankSelectable = false, currentLevel = 1, maxChildLevel, isCreditCardSelectable = null): any[]{
        const accountTypes: any[] = [];
        if (accounts.length > 0) {
            for (let account of accounts) {
                let parentNode = {
                    id: account.id,
                    label: `${account.displayNumber || ""} - ${account.name}`,
                    displayValue: account.name,
                    value: account,
                    children: this.getChildAccountTypes(isChildSelectable, account, isBankSelectable, currentLevel, maxChildLevel, isCreditCardSelectable),
                    selectable: isParentSelectable,
                    subAccountType: account.subAccountType,
                };
                accountTypes.push(parentNode);
            }
        }
        return accountTypes;
    }
    private getChildAccountTypes(isChildSelectable, account, isBankSelectable = false, currentLevel, maxChildLevel, isCreditCardSelectable = null): any[] {
        let childData: any[] = [];
        if(currentLevel <= maxChildLevel){
            if(account?.childAccounts?.length > 0){
                for (let child of account.childAccounts) {
                    let childNode = {
                        id: child.id,
                        label: `${child.displayNumber || ""} - ${child.name}`,
                        displayValue: child.name,
                        value: child,
                        children: this.getChildAccountTypes(isChildSelectable, child, isBankSelectable, currentLevel + 1, maxChildLevel),
                        selectable: child?.name?.toLowerCase() == 'bank' ? isBankSelectable : isCreditCardSelectable != null && child?.name?.toLowerCase() == 'credit card' ? isCreditCardSelectable : isChildSelectable,
                        subAccountType: child.subAccountType,
                    };
                    childData.push(childNode);
                }
            }
        }
        return childData;
    }

    /** Recursive method to prepare financial account data */
    prepareFinancialAccountsData(accounts): any[] {
        let data: any[] = []
        for (let account of accounts) {
            let parentNode = {
                id: account.id,
                name: account.name ,
                label: `${account.displayNumber || ""} - ${account.name}`,
                value: account,
                children: this.prepareChildFinancialAccountsData(account),
                selectable: account.parentFinancialAccountId != 0,
                subAccountType: account.subAccountType,
            }
            data.push(parentNode);
        }
        return data;
    }
    private prepareChildFinancialAccountsData(account): any[] {
        let childData: any[] = [];
        for (let child of account.childAccounts) {
            let childNode = {
                id: child.id,
                name: child.name ,
                label: `${child.displayNumber || ""} - ${child.name}`,
                value: child,
                children: this.prepareChildFinancialAccountsData(child),
                selectable: child?.name?.toLowerCase() == 'bank' ? false : child.parentFinancialAccountId != 0,
                subAccountType: child.subAccountType,
            }
            childData.push(childNode);
        }
        return childData;
    }

    /** Recursive method to prepare hierarchical class data */
    prepareHierarchicalClassData(data): any[] {
        let hierarchicalData: any[] = []
        for (let d of data) {
            let parentNode = {
                id: d.id,
                label: d.name,
                name: d.name,
                value: d,
                children: this.prepareChildData(d),
                selectable: true,
            }
            hierarchicalData.push(parentNode);
        }
        return hierarchicalData;
    }
    private prepareChildData(data): any[] {
        let childData: any[] = [];
        for (let child of data.childClass) {
            let childNode = {
                id: child.id,
                label: child.name,
                name: child.name,
                value: child,
                children: this.prepareChildData(child),
                selectable: true,
            }
            childData.push(childNode);
        }
        return childData;
    }

    // Recursive function to find child objects
    findRecursiveChildObjects(treeNodes: any[], targetId: number): any {
        for (const node of treeNodes) {
            const foundNode = this.findRecursiveChild(node, targetId);
            if (foundNode) {
                return foundNode;
            }
        }
        return null;
    }
    private findRecursiveChild(node: any, targetId: number): any {
        if (node?.value?.id === targetId) {
            return node;
        }
        if (node?.children) {
            for (const child of node.children) {
                const foundNode = this.findRecursiveChild(child, targetId);
                if (foundNode) {
                    return foundNode;
                }
            }
        }
        return null;
    }

    showTrackingOption(trackingOptions: any[], option: string, savedOption: any): boolean {
        if (savedOption) {
            if (savedOption[`${option}`]) {
                return trackingOptions?.some(track => track.code === option && track.enabled);
            } else {
                return false;
            }
        } else {
            return trackingOptions?.some(track => track.code === option && track.enabled);
        }
    }

    displayName(trackingOptions,code,type) {
        if (type === 'label') {
            return trackingOptions?.find(opt => opt.code == code)?.name;
        }else if (type === 'currency') {
            return trackingOptions?.find(opt => opt.code == code)?.currencySymbol;
        } else {
            return trackingOptions?.find(opt => opt.code == code)?.formControlName;
        }
    }

    getDecimalValue(trackingOptions: any[],code) {
        return trackingOptions?.find(opt => opt.code == code)?.noOfDecimal;
    }

    validateJournalEntryDebitCredit(formArray: FormArray): boolean {     
        let isValid = true;     
        formArray?.controls?.forEach(group => {       
            const debit = group?.get('debit')?.value;       
            const credit = group?.get('credit')?.value;       
            
            if ((debit && credit) || (!debit && !credit)) {         
                // group.setErrors({ debitOrCredit: true });         
                isValid = false; 
            } else { 
                // group.setErrors(null); 
            } 
        });
        return isValid; 
    }

}